// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registerStep1Container {
  display: flex;
  justify-content: center;
    width: 100%;
    padding: 0 20px;
}

.registerStep1Container form{
    width: 100%;
    max-width: 500px;
}

.registerStep1Container .blason {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.registerStep1Container .blason p {
    color: #C3D32C;
    text-align: center;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.registerStep1Container form .fileUploadContainer {
    position: relative;
    width: 150px;
    height: 150px;
  }
  
  .registerStep1Container form #fileInput {
    display: none;
  }
  
  .registerStep1Container form .fileLabel {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #6c6c6c;
    cursor: pointer;
  }
  
  .registerStep1Container form .fileCircle {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #CCC;
    overflow: hidden;
    position: relative;
  }
  
  .registerStep1Container form .plusIcon {
    color: #8b8b8b;
    padding: 0;
  }
  
  .registerStep1Container form .uploadedImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }


  .registerStep1Container form .registerStep1Container form {
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .registerStep1Container form .inputGroup {
    display: flex;
    gap: 15px;
    margin-bottom: 0;
    margin-top: 16px;
  }
  
  .registerStep1Container .inputWithIcon {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 8px;
  }
  
  .registerStep1Container .inputWithIcon input {
    width: 100%;
    padding: 12px 10px 12px 40px;
    border-radius: 10px;
    border: none;
    background-color: #f0f0f0;
    font-size: 16px;
  }
  
  .registerStep1Container .inputWithIcon svg {
    position: absolute;
    left: 10px;
    color: #666;
  }
  
  .registerStep1Container .termsContainer {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 14px;
  }
  
  .registerStep1Container .termsContainer input {
    margin: 0;
  }
  
  .registerStep1Container .termsContainer p {
    color: #C3D32C;
    margin: 8px 0;
  }
  
  .registerStep1Container .termsContainer a {
    color: #C3D32C;
    text-decoration: underline;
  }
  
  .registerStep1Container form button {
    margin-top: 16px;
    padding: 16px;
    border: none;
    border-radius: 30px;
    background-color: #C3D32C;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
  }

  .registerStep1Container form input.invalid{
    border: red 2px solid;
  }

  .registerStep1Container form .termsContainer.invalid p{
    color: red;
  }
  
  .selectTournament{
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding-bottom: 16px;
    border-bottom: 2px solid #7499ff11;
  }

  .selectTournament select {
    width: 100%;
    padding: 12px 10px;
    border-radius: 10px;
    border: none;
    background-color: #f0f0f0;
    font-size: 16px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    color: #666;
  }
  
  .selectTournament select.invalid {
    border: red 2px solid;
  }
  

.inputGroup select.invalid {
    border: red 2px solid;
}`, "",{"version":3,"sources":["webpack://./src/components/Register/RegisterStep1.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;IACrB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;EAChC;;;EAGA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,oBAAoB;IACpB,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;;AAGF;IACI,qBAAqB;AACzB","sourcesContent":[".registerStep1Container {\r\n  display: flex;\r\n  justify-content: center;\r\n    width: 100%;\r\n    padding: 0 20px;\r\n}\r\n\r\n.registerStep1Container form{\r\n    width: 100%;\r\n    max-width: 500px;\r\n}\r\n\r\n.registerStep1Container .blason {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.registerStep1Container .blason p {\r\n    color: #C3D32C;\r\n    text-align: center;\r\n    font-family: Lato;\r\n    font-size: 12px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n}\r\n\r\n.registerStep1Container form .fileUploadContainer {\r\n    position: relative;\r\n    width: 150px;\r\n    height: 150px;\r\n  }\r\n  \r\n  .registerStep1Container form #fileInput {\r\n    display: none;\r\n  }\r\n  \r\n  .registerStep1Container form .fileLabel {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    background-color: #6c6c6c;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .registerStep1Container form .fileCircle {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    background-color: #CCC;\r\n    overflow: hidden;\r\n    position: relative;\r\n  }\r\n  \r\n  .registerStep1Container form .plusIcon {\r\n    color: #8b8b8b;\r\n    padding: 0;\r\n  }\r\n  \r\n  .registerStep1Container form .uploadedImage {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    object-position: center center;\r\n  }\r\n\r\n\r\n  .registerStep1Container form .registerStep1Container form {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n  }\r\n  \r\n  .registerStep1Container form .inputGroup {\r\n    display: flex;\r\n    gap: 15px;\r\n    margin-bottom: 0;\r\n    margin-top: 16px;\r\n  }\r\n  \r\n  .registerStep1Container .inputWithIcon {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .registerStep1Container .inputWithIcon input {\r\n    width: 100%;\r\n    padding: 12px 10px 12px 40px;\r\n    border-radius: 10px;\r\n    border: none;\r\n    background-color: #f0f0f0;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .registerStep1Container .inputWithIcon svg {\r\n    position: absolute;\r\n    left: 10px;\r\n    color: #666;\r\n  }\r\n  \r\n  .registerStep1Container .termsContainer {\r\n    margin-top: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .registerStep1Container .termsContainer input {\r\n    margin: 0;\r\n  }\r\n  \r\n  .registerStep1Container .termsContainer p {\r\n    color: #C3D32C;\r\n    margin: 8px 0;\r\n  }\r\n  \r\n  .registerStep1Container .termsContainer a {\r\n    color: #C3D32C;\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  .registerStep1Container form button {\r\n    margin-top: 16px;\r\n    padding: 16px;\r\n    border: none;\r\n    border-radius: 30px;\r\n    background-color: #C3D32C;\r\n    color: #fff;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    width: 100%;\r\n  }\r\n\r\n  .registerStep1Container form input.invalid{\r\n    border: red 2px solid;\r\n  }\r\n\r\n  .registerStep1Container form .termsContainer.invalid p{\r\n    color: red;\r\n  }\r\n  \r\n  .selectTournament{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    width: 100%;\r\n    padding-bottom: 16px;\r\n    border-bottom: 2px solid #7499ff11;\r\n  }\r\n\r\n  .selectTournament select {\r\n    width: 100%;\r\n    padding: 12px 10px;\r\n    border-radius: 10px;\r\n    border: none;\r\n    background-color: #f0f0f0;\r\n    font-size: 16px;\r\n    appearance: none;\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    cursor: pointer;\r\n    color: #666;\r\n  }\r\n  \r\n  .selectTournament select.invalid {\r\n    border: red 2px solid;\r\n  }\r\n  \r\n\r\n.inputGroup select.invalid {\r\n    border: red 2px solid;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
